var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.02539C0 7.49805 0.397461 7.89551 0.870117 7.89551H6.15527V13.1807C6.15527 13.6426 6.55273 14.0508 7.02539 14.0508C7.49805 14.0508 7.88477 13.6426 7.88477 13.1807V7.89551H13.1807C13.6426 7.89551 14.04 7.49805 14.04 7.02539C14.04 6.55273 13.6426 6.15527 13.1807 6.15527H7.88477V0.870117C7.88477 0.408203 7.49805 0 7.02539 0C6.55273 0 6.15527 0.408203 6.15527 0.870117V6.15527H0.870117C0.397461 6.15527 0 6.55273 0 7.02539Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.c383937eed3d5def5286ff39c4157747.svg";
export { ForwardRef as ReactComponent };